import React from 'react';
import { graphql } from 'gatsby';

import SectionItemContentFramedHeadline from '../../../../components/Section/SectionItems/SectionItemContentFramedHeadline';
import { normalizeTextAlign } from '../../utils';

// Types
import { SectionItemContentFramedHeadlineContainerFragment } from './__generated__/SectionItemContentFramedHeadlineContainerFragment';
import { SectionWidth } from '../../../../../types/sections';

export const fragment = graphql`
  fragment SectionItemContentFramedHeadlineContainerFragment on CMS_Section {
    headline
    headlineColor
    textAlign
  }
`;

type Props = {
  contentPositionY: string;
  hasBackgroundImage: boolean;
  section: SectionItemContentFramedHeadlineContainerFragment;
  sectionWidth: SectionWidth;
};

const SectionItemContentFramedHeadlineContainer = ({ contentPositionY, hasBackgroundImage, section, sectionWidth }: Props) => {
  const headline = section.headline;

  if (typeof headline !== 'string') {
    return null;
  }

  const textAlign = normalizeTextAlign(section.textAlign);
  const textColor = section.headlineColor;

  return (
    <SectionItemContentFramedHeadline
      contentPositionY={contentPositionY}
      hasBackgroundImage={hasBackgroundImage}
      sectionWidth={sectionWidth}
      text={headline}
      textAlign={textAlign}
      textColor={textColor}
    />
  );
};

export default SectionItemContentFramedHeadlineContainer;
